import al from "../images/all_countries_flags/al.png"
import at from "../images/all_countries_flags/at.png"
import ba from "../images/all_countries_flags/ba.png"
import by from "../images/all_countries_flags/by.png"
import be from "../images/all_countries_flags/be.png"
import bg from "../images/all_countries_flags/bg.png"
import ch from "../images/all_countries_flags/ch.png"
import hr from "../images/all_countries_flags/hr.png"
import cy from "../images/all_countries_flags/cy.png"
import cz from "../images/all_countries_flags/cz.png"
import dk from "../images/all_countries_flags/de.png"
import de from "../images/all_countries_flags/de.png"
import ee from "../images/all_countries_flags/ee.png"
import fi from "../images/all_countries_flags/fi.png"
import fr from "../images/all_countries_flags/fr.png"
import ge from "../images/all_countries_flags/ge.png"
import gr from "../images/all_countries_flags/gr.png"
import es from "../images/all_countries_flags/es.png"
import hu from "../images/all_countries_flags/hu.png"
import ie from "../images/all_countries_flags/ie.png"
import is from "../images/all_countries_flags/is.png"
import it from "../images/all_countries_flags/it.png"
import xk from "../images/all_countries_flags/xk.png"
import li from "../images/all_countries_flags/li.png"
import lv from "../images/all_countries_flags/lv.png"
import lt from "../images/all_countries_flags/lt.png"
import lu from "../images/all_countries_flags/lu.png"
import mt from "../images/all_countries_flags/mt.png"
import md from "../images/all_countries_flags/md.png"
import me from "../images/all_countries_flags/me.png"
import mk from "../images/all_countries_flags/mk.png"
import nl from "../images/all_countries_flags/nl.png"
import no from "../images/all_countries_flags/no.png"
import pl from "../images/all_countries_flags/pl.png"
import pt from "../images/all_countries_flags/pt.png"
import ro from "../images/all_countries_flags/ro.png"
import ru from "../images/all_countries_flags/ru.png"
import rs from "../images/all_countries_flags/rs.png"
import sl from "../images/all_countries_flags/sl.png"
import sk from "../images/all_countries_flags/sk.png"
import se from "../images/all_countries_flags/se.png"
import tr from "../images/all_countries_flags/tr.png"
import ua from "../images/all_countries_flags/ua.png"
import gb from "../images/all_countries_flags/gb.png"

export const europeCountries = [
    {name: 'Albania', code: 'al', logo: al}, //Albania
    {name: 'Austria', code: 'at', logo: at}, //Austria
    {name: 'Bosnia', code: 'ba', logo: ba}, //Bosnia
    {name: 'Belarus', code: 'by', logo: by},
    {name: 'Belgium', code: 'be', logo: be}, // Belgique/België	Belgium	Belgique	Belgien
    {name: 'Bulgaria', code: 'bg', logo: bg}, // Bulgarija	Bulgaria	Bulgarie	Bulgarien
    {name: 'Switzerland', code: 'ch', logo: ch}, //Switzerland
    {name: 'Croatia', code: 'hr', logo: hr}, //Crotia
    {name: 'Cyprus', code: 'cy', logo: cy}, //Cyprus
    {name: 'Czech Republic', code: 'cz', logo: cz}, // Česko	Czechia	Tchéquie	Tschechien
    {name: 'Denmark', code: 'dk', logo: dk}, // Danmark	Denmark	Danemark	Dänemark
    {name: 'Germany', code: 'de', logo: de}, // Deutschland	Germany	Allemagne	Deutschland
    {name: 'Estonia', code: 'ee', logo: ee}, // Eesti	Estonia	Estonie	Estland
    {name: 'Finland', code: 'fi', logo: fi}, //Finland
    {name: 'France', code: 'fr', logo: fr}, // France	France	France	Frankreich
    {name: 'Georgia', code: 'ge', logo: ge}, //Georgia
    {name: 'Greece', code: 'gr', logo: gr}, // Elláda	Greece	Grèce	Griechenland
    {name: 'Spain', code: 'es', logo: es}, // España	Spain	Espagne	Spanien
    {name: 'Hungary', code: 'hu', logo: hu}, //Hungary
    {name: 'Ireland', code: 'ie', logo: ie}, // Éire/Ireland	Ireland	Irlande	Irland
    {name: 'Iceland', code: 'is', logo: is}, //Iceland
    {name: 'Italy', code: 'it', logo: it}, // Italia	Italy	Italie	Italien
    {name: 'Kosovo', code: 'xk', logo: xk},
    {name: 'Liechtenstein', code: 'li', logo: li}, //Liechtenstein
    {name: 'Latvia', code: 'lv', logo: lv}, // Latvija	Latvia	Lettonie	Lettland
    {name: 'Lithuania', code: 'lt', logo: lt}, // Lietuva	Lithuania	Lituanie	Litauen
    {name: 'Luxembourg', code: 'lu', logo: lu}, // Luxembourg	Luxembourg	Luxembourg	Luxemburg
    {name: 'Malta', code: 'mt', logo: mt},
    {name: 'Moldova', code: 'md', logo: md}, //Montenegro
    {name: 'Montenegro', code: 'me', logo: me}, //Montenegro
    {name: 'North Macedonia', code: 'mk', logo: mk}, //North Macedonia
    {name: 'Netherlands', code: 'nl', logo: nl}, // Nederland	Netherlands	Pays-Bas	Niederlande
    {name: 'Norway', code: 'no', logo: no}, //Norway
    {name: 'Poland', code: 'pl', logo: pl}, // Polska	Poland	Pologne	Polen
    {name: 'Portugal', code: 'pt', logo: pt}, // Portugal	Portugal	Portugal	Portugal
    {name: 'Romania', code: 'ro', logo: ro}, // România	Romania	Roumanie	Rumänien
    {name: 'Russia', code: 'ru', logo: ru},
    {name: 'Serbia', code: 'rs', logo: rs}, //Serbia
    {name: 'Slovenia', code: 'sl', logo: sl}, // Slovenija	Slovenia	Slovénie	Slowenien
    {name: 'Slovakia', code: 'sk', logo: sk}, // Slovensko	Slovakia	Slovaquie	Slowakei
    {name: 'Sweden', code: 'se', logo: se}, // Sverige	Sweden	Suède	Schweden,
    {name: 'Turkey', code: 'tr', logo: tr}, //Turkey
    {name: 'Ukraine', code: 'ua', logo: ua}, //Ukraine,
    {name: 'United Kingdom', code: 'gb', logo: gb}
];